import { ClockInstant } from '../store/types'

// take a clock instant and calculate how long ago the instant was and how much is remaining now
export const getClockInstantCurrentRemaining = (clockInstant: ClockInstant | undefined): number => {
    if (!clockInstant) return 0
    const now = new Date().getTime()
    return Math.max(0, clockInstant.secondsRemaining - (now - clockInstant.when) / 1000)
}
